import { createAction, props } from '@ngrx/store';
import { Manual, ManualFile } from './manuals.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records manuals'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records manuals success', 
    props<{ listData: Manual[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records manuals failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record manuals',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record manuals success', 
    props<{ singleData: Manual, files: ManualFile[] }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record manuals failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record manuals',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record manuals success'
);
export const addRecordFailure = createAction(
    '[Data] Add record manuals failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record manuals',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record manuals success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record manuals failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record manuals',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record manuals success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record manuals failure',
    props<{ error: string }>()
);


// Delete File
export const deleteFileRecord = createAction(
    '[Data] Delete record manuals file',
    props<{ taskId: string, id: string }>()
);
export const deleteFileRecordSuccess = createAction(
    '[Data] Delete record manuals file success'
);
export const deleteFileRecordFailure = createAction(
    '[Data] Delete record manuals file failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);